export const STANDING_ORDERS_CONFIG = {
  oxygenByOptions: [
    { display: "Simple face mask", value: "Simple Face mask" },
    {
      display: "Non re-breather face mask",
      value: "Non re-breather face mask",
    },
    { display: "Nasal prongs", value: "Nasal prongs" },
    { display: "Tracheostomy mask", value: "Tracheostomy mask" },
    {
      display: "Tracheostomy HME connector",
      value: "Tracheostomy HME connector",
    },
    { display: "Isollete - neonates", value: "Isollete - neonates" },
    { display: "Other", value: "Other" },
  ],
  oxygenAtOptions: [
    { display: "1", value: "1" },
    { display: "2", value: "2" },
    { display: "3", value: "3" },
    { display: "4", value: "4" },
    { display: "5", value: "5" },
    { display: "6", value: "6" },
    { display: "7", value: "7" },
    { display: "8", value: "8" },
    { display: "9", value: "9" },
    { display: "10", value: "10" },
  ],
  oxygenPercentages: [
    { display: "10%", value: "10%" },
    { display: "20%", value: "20%" },
    { display: "30%", value: "30%" },
    { display: "40%", value: "40%" },
    { display: "50%", value: "50%" },
    { display: "60%", value: "60%" },
    { display: "70%", value: "70%" },
    { display: "80%", value: "80%" },
    { display: "90%", value: "90%" },
    { display: "100%", value: "100%" },
  ],
  captionAndVariables: [
    {
      dbVarName: "Nurse to evaluate/monitor/assess need",
      captionName: "nurseToEvaluateNeed",
      variableName: "nurseToEvaluate",
    },
    {
      dbVarName: "Aide to perform personal hygiene/assist ADLs/safety",
      captionName: "aideToPerformPersonalHygiene",
      variableName: "perosnalHygiene",
    },
    {
      dbVarName:
        "Social worker to counsel/assess psychosocial/social related to illness/assess/financial/refer as appropriate",
      captionName: "socialWorkerToCounsel",
      variableName: "socialWorker",
    },
    {
      dbVarName: "Chaplin/counselor assess spiritual needs",
      captionName: "counselorAssessSpiritualNeeds",
      variableName: "spiritualNeeds",
    },
    {
      dbVarName: "Volunteer",
      captionName: "volunteer",
      variableName: "volunteer",
    },
  ],
  soStatus: {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    DISCONTINUE: "DISCONTINUED",
    CREATED: "IN PROGRESS...",
  },
};



// WEBPACK FOOTER //
// ./src/pages/orders/standing-orders/standing-orders-config.ts